import { render, staticRenderFns } from "./BlankLayoutMaster.vue?vue&type=template&id=9cbd50c6&"
import script from "./BlankLayoutMaster.vue?vue&type=script&lang=js&"
export * from "./BlankLayoutMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports